export const startupEngineer = {
  id: 'startup-engineer',
  version: 2,
  renderer: 'enterprise',
  name: 'Startup Engineer Modern',
  layout: 'single-column',
  theme: 'modern-teal',
  persona: ['software', 'frontend', 'javascript', 'react', 'engineering'],
  atsLevel: 'B+',
  scoreWeights: {
    ats: 30,
    visual: 45,
    executive: 10,
    student: 15
  },
  sectionOrder: ['personal-info', 'summary', 'skills', 'experience', 'projects', 'education'],
  components: {
    header: 'header-centered',
    experience: 'experience-classic',
    projects: 'projects-list',
    skills: 'skills-categorized',
    education: 'education-section'
  },
  metadata: {
    industry: ['Tech Startups', 'Fintech', 'AI Startups'],
    companies: ['Stripe', 'Airbnb', 'Uber', 'Figma', 'Vercel', 'Supabase', 'HashiCorp'],
    ats: ['Lever', 'Greenhouse', 'Ashby'],
    pages: { min: 1, max: 2, preferred: 1 },
    photo: true,
    icons: true,
    density: 'comfortable',
    columns: 1,
    experienceLevel: ['Entry-level', 'Mid-level', 'Senior'],
    careerStage: 'Professional',
    recommendedFor: ['Frontend Developers', 'UI Engineers', 'Product Engineers', 'Full Stack Developers'],
    avoidFor: ['Investment Bankers', 'Federal Employees', 'Corporate Executives'],
    dna: ['Modern-Teal', 'Creative-Tech', 'Visual-Highlights', 'Sans-Serif', 'Vibrant'],
    metrics: {
      readingDifficulty: 92,
      scanningSpeed: 93,
      visualAppeal: 96
    },
    hiringManager: {
      firstImpression: "Vibrant, product-minded engineer with a sense of design aesthetics",
      scanningStyle: "Linear scanning focusing on summary, visual tech tags, and project outcomes",
      preferredStructure: "Summary, skills at the top, experience, projects, education",
      dislikes: ["Dry black-and-white printouts", "No Github/portfolio link", "Academic styles"]
    },
    strategy: {
      goal: "Provide a creative single-column modern layout for startup ecosystems",
      focus: "Technical skill tags, project live links, and product impact description",
      avoid: ["Traditional serif fonts", "Dense corporate formatting"]
    },
    psychology: {
      coreTraits: ["Creativity", "Innovation", "Product-ownership", "Energy"]
    },
    readingPattern: {
      fPattern: true,
      zPattern: true,
      linear: true,
      sidebar: false
    },
    aiPrompt: {
      writingStyle: "Use a friendly but professional tone. Highlight product impact, user experience improvements, and ownership of features. Describe technologies in a clean stack.",
      rewriteStyle: "Modern, product-minded, clean"
    },
    accessibility: {
      contrast: "AAA",
      fontSizeMin: "9.5pt",
      lineHeight: 1.45,
      screenReaderHeading: true
    },
    print: {
      a4: true,
      letter: true,
      inkSaving: false,
      cmykSafe: true
    },
    export: {
      pdf: true,
      docx: true,
      latex: false,
      html: true
    }
  },
  layouts: {
    'single-column': {
      component: 'single-column',
      slots: {
        header: ['personal-info'],
        main: ['summary', 'skills', 'experience', 'projects', 'education']
      },
      overrides: {
        '--font-family-primary': '"Inter", sans-serif',
        '--spacing-margin': '18px'
      }
    }
  },
  styleOverrides: {
    '--font-size-display': '26pt',
    '--weight-display': '800',
    '--heading-text-transform': 'none',
    '--heading-weight': '600',
    '--border-thickness-heading': '3px',
    '--bullet-style': 'square',
    '--spacing-section-mb': '22px',
    '--spacing-item-mb': '12px',
    '--spacing-bullet-gap': '5px',
    '--color-text-main': '#2D3748',
    '--color-text-light': '#718096'
  }
};
export default startupEngineer;
